// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreviewAccordion-module--wrapper--272zw"};